import React, { memo } from 'react'
import ReactMarkdown from 'react-markdown'
import styled from 'styled-components'

export interface ScoringTooltipMarkdownProps {
  text: string | undefined
}

export const ScoringTooltipMarkdown = memo(function ScoringTooltipMarkdown({
  text
}: ScoringTooltipMarkdownProps): JSX.Element | null {
  if (!text) return null
  return (
    <ReactMarkdown
      components={{
        p: ({ children }) => <MarkdownParagraph>{children}</MarkdownParagraph>
      }}
    >
      {text}
    </ReactMarkdown>
  )
})

const MarkdownParagraph = styled.span`
  display: block;
  margin: 0;
`
